import { jsx as _jsx } from "react/jsx-runtime";
import { Button, ButtonShape, ButtonVariant } from '@as/cotopaxi';
export const QuickFilterItem = ({ quickLink }) => (_jsx(Button, { variant: ButtonVariant.FILTER_ALT, shape: ButtonShape.PILL, title: quickLink.linkName, href: `${quickLink.linkPath}${quickLink.queryStringParams || ''}`, text: quickLink.linkName }));
